<template>
  <div>
    <input-title />
    <input-locale />
    <ButtonUpdate class="mt_m" />
  </div>
</template>

<script>
import InputTitle from '@/components/Home/InputTitle'
import InputLocale from '@/components/Home/InputLocale'
import ButtonUpdate from '@/components/Home/ButtonUpdate'

export default {
  components: {
    InputTitle,
    InputLocale,
    ButtonUpdate,
  },

  created: async function () {
    await this.$store.dispatch('app/getApp')
    await this.$store.dispatch('app/initForm')
  },
}
</script>

<style lang="scss" scoped>
</style>
